import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * [통합 로그 > 시스템 로그] 설정 API
 */
export default {
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] objId로 장비에 할당된 정책 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogRuleByObj(params) {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-syslog-rule-by-obj.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] 장비에 정책을 추가한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/insert-syslog-rule.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] 정책을 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/delete-syslog-rule.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] 정책을 업데이트한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogRule(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/update-syslog-rule.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] 정책이 할당된 장비 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogRuleTargets(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/get-syslog-rule-targets.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 정책 설정] 정책을 여러 장비에 그룹 저장한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogRuleTargets(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/update-syslog-rule-targets.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정 팝업] 수집 서버 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogCollectors() {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-log-collectors.do`);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정 팝업] 저장소 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getDataIndexes() {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-data-indexes.do`);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정 팝업] 콤보박스에서 선택한 저장소의 패턴 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPatternByIndex(params) {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-pattern-by-index.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 >  수집 설정] objCompanyId별 네트워크 장비 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSyslogGroupSetList(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/get-syslog-group-set-list.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정] 장비별 수집 여부를 업데이트한다. (lms_log_info 테이블도 같이 업데이트)
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogCollectFlag(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/update-syslog-collect-flag.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정] 장비의 objId로 단일 로그 객체 정보를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getLogInfoByObjId(params) {
    return axios.get(`${baseUrl}/settings/integrated-syslog/get-log-info-by-obj-id.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정] 장비의 로그 객체 정보를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSyslogLogInfo(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/update-syslog-log-info.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정] 파일 비밀번호 변경 시 파일의 현재 비밀번호를 확인한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkFileCurrentPassword(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/check-file-current-password.do`, params);
  },
  /**
   * [통합 로그 > 시스템 로그 > 수집 설정] 파일 비밀번호를 변경한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateFilePassword(params) {
    return axios.post(`${baseUrl}/settings/integrated-syslog/update-file-password.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/integrated-syslog-settings.js